module.exports = __webpack_public_path__ + "img/8.ded80b65.jpg";